import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Spices from './pages/Spices';
import Onion from './pages/Onion';
import Garlik from './pages/Garlik';
import Raisins from './pages/Raisins';
import Vegetable from './pages/Vegetable';
import ProductDetails from './pages/ProductDetails';
import About from './pages/About';
import Contact from './pages/Contact';
import Certificate from './pages/Certificate';
import { Toaster } from 'react-hot-toast';


function App() {
  return (
    <>
      <Router>
        <Toaster
          position="top-center"
          reverseOrder={false}
        />
        <Routes>
          <Route path='/' Component={Home} />
          <Route path='/about' Component={About} />
          <Route path='/spices' Component={Spices} />
          <Route path='/onion' Component={Onion} />
          <Route path='/garlic' Component={Garlik} />
          <Route path='/raisins' Component={Raisins} />
          <Route path='/vegetable' Component={Vegetable} />
          <Route path='/:type/:id' Component={ProductDetails} />
          <Route path='/contact' Component={Contact} />
          <Route path='/certificates' Component={Certificate} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
